import React from 'react';
import PrimaryButton from '../PrimaryButton';

function ConfirmDialog({ title, confirmText, onCancel, onConfirm }) {
  return (
    <>
      <div className="dialog-modal">
        <div className="dialog-content">
          <div className="dialog-title"> {title}</div>
          <div className="dialog-buttons">
            <PrimaryButton text={'Cancel'} onClick={onCancel} />
            <PrimaryButton text={confirmText} onClick={onConfirm} />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .dialog-modal {
            position: fixed;
            background-color: rgba(0, 0, 0, 0.75);
            z-index: 10;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .dialog-content {
            background-color: #242424;
            padding: 24px;
            border-radius: 15px;
          }
          .dialog-title {
            font-size: 18px;
          }
          .dialog-button {
            outline: none;
            border: none;
            background-color: ;
          }
          .dialog-buttons {
            display: flex;
            gap: 12px;
            margin-top: 20px;
            justify-content: center;
          }
        `}
      </style>
    </>
  );
}

export default ConfirmDialog;
